<script setup lang="ts">
/** Quiz/Glass pill 3182:14887 — "About 3 min", "Saved as you go", "Picked by AIRA". */
import { FairIcon } from '@/ui/primitives/FairIcon'

interface FairQuizGlassPillProps {
  label: string
  star?: boolean
}

withDefaults(defineProps<FairQuizGlassPillProps>(), {
  star: true,
})
</script>

<template>
  <span class="fair-quiz-pill">
    <FairIcon
      v-if="star"
      class="fair-quiz-pill__star"
      name="ai"
      :size="16"
    />
    <span class="fair-quiz-pill__label">{{ label }}</span>
  </span>
</template>
